import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUsersSupervisorsService } from "services/UsersSupervisorsService";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  SubordinateSelectModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const subordinateSelectSlice = createSlice({
  name: "subordinateSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSubordinateSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getSubordinateSelectModels.fulfilled, (state, action) => {
        state.SubordinateSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      })
      .addCase(getSubordinateSelectModels.rejected, (state) => {
        state.Loading = false;
      });
  },
});

export const getSubordinateSelectModels = createAsyncThunk("Subordinates/GetSelectModels", async () => {
  const usersSupervisorsService = container.get<IUsersSupervisorsService>(SERVICE_TYPES.UsersSupervisorsService);
  return await usersSupervisorsService.getSubordinateSelectModels();
});

export const selectSubordinateSelectModels = (state: RootState) => {
  return state.subordinateSelect.SubordinateSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.subordinateSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.subordinateSelect.LastUpdateTime;
};

export default subordinateSelectSlice.reducer;
